<!--
  ~ Copyright (c) 2022. Slimme Infrasoftware B.V. Apeldoorn /
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden
  ~ volgens de voorwaarden die zijn vastgelegd in de overeenkomst
  ~ tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
  ~ overeenkomsten tussen Slimme Infrasoftware B.V en
  ~ Spin in het Web B.V.
  -->


<datatable #datatable [definition]="tableDefinition" [data]="tableData" [autoUpdate]="false" stickyheaders
           (rijklik)="edit($event.id)"></datatable>
<div class="footer">
  <div links>{{datatable.filterRijen}} / {{datatable.rijen}}
    <button class="btn btn-outline-light ml-2" title="Synchroniseer Exact" *ngIf="api.can('exact', 'sync') || api.can('project','full')" (click)="api.syncExact()"><span class="fas fa-sync"></span></button>
  </div>
</div>
